import { Switch } from '@thanx/uikit/switch'
import useFlag from 'hooks/useFlag'
import { buildTranslate } from 'locales'
import isEmpty from 'lodash/isEmpty'
import { useState } from 'react'
import { I18n } from 'react-redux-i18n'
import ModifierToggle from 'scenes/RedeemManager/Builder/ConfigurationStep/ModifierToggle'
import {
  getDiscountedModifiersText,
  getDiscountedProductsText,
} from 'scenes/RedeemManager/helpers'
import { RedeemTypeItem } from 'scenes/RedeemManager/types'
import ModifierSelect from './ModifierSelect'
import ProductSelect from './ProductSelect'

const t = buildTranslate(
  'redeem_manager.builder.steps.configuration.online_redemption_card'
)

type NotPurchaseProps = {
  discountedProductIds: string[]
  discountedModifierIds: string[]
  requiredProductIds: string[]
  typeItem: RedeemTypeItem | null
}

const NotPurchase = ({
  discountedProductIds,
  discountedModifierIds,
  requiredProductIds,
  typeItem,
}: NotPurchaseProps) => {
  const hasDiscountedModifierIds = Boolean(
    Array.isArray(discountedModifierIds) && discountedModifierIds.length > 0
  )
  const hasDiscountedProductIds = Boolean(
    Array.isArray(discountedProductIds) && discountedProductIds.length > 0
  )
  const [isModifierToggleVisible, setIsModifierToggleVisible] = useState(
    hasDiscountedModifierIds
  )
  const subtype = typeItem?.subtype
  const itemOrBogoItem = subtype === 'item' || subtype === 'bogo/item'
  const displayDiscountedProducts =
    itemOrBogoItem || (subtype === null && !isEmpty(discountedProductIds))
  const nullSubtypeAndModifiersPresent =
    subtype === null && !isEmpty(discountedModifierIds)
  const freeModifierRewardsEnabled = useFlag('mx-free-modifier-rewards', false)
  const displayDiscountedModifiers =
    freeModifierRewardsEnabled &&
    (itemOrBogoItem || nullSubtypeAndModifiersPresent)
  const displayRequiredProducts =
    subtype === 'bogo/item' ||
    subtype === 'bogo/purchase' ||
    (subtype === null && !isEmpty(requiredProductIds))
  const isFreeItem = typeItem?.types.includes('manual/item')
  const isFreeModifier = subtype?.includes('modifier') ?? false
  const {
    label: modifiersLabel,
    helpText: modifiersHelpText,
    secondaryHelpText: modifiersSecondaryHelpText,
  } = getDiscountedModifiersText(subtype)

  return (
    <>
      <Switch condition={displayRequiredProducts}>
        <ProductSelect
          className="mb-m"
          name="onlineRequiredProductIds"
          label={t('required_label')}
          fallbackLabel={t('required_label_fallback')}
          isFreeItem={isFreeItem}
          value={requiredProductIds}
          validations={{ isRequired: true }}
          validationErrors={{
            isRequired: I18n.t('validations.is_required'),
          }}
        />
      </Switch>
      <Switch condition={displayDiscountedProducts}>
        <>
          <ProductSelect
            label={getDiscountedProductsText(isFreeItem, subtype).label}
            fallbackLabel={t(
              isFreeItem
                ? 'discounted_label_free_item_fallback'
                : 'discounted_label_fallback'
            )}
            name="onlineDiscountedProductIds"
            isFreeItem={isFreeItem}
            value={discountedProductIds}
            validations={{ isRequired: true }}
            validationErrors={{
              isRequired: I18n.t('validations.is_required'),
            }}
          />
          <p className="mt-xs body-text-4 grey-70">
            {isFreeItem
              ? t('will_apply_lowest_free_item')
              : t('will_apply_lowest')}
          </p>
          <Switch condition={freeModifierRewardsEnabled}>
            <p className="mt-xs body-text-4 grey-70">{t('including_addons')}</p>
          </Switch>
        </>
      </Switch>
      <Switch condition={displayDiscountedModifiers}>
        <ModifierToggle
          isVisible={isModifierToggleVisible}
          setIsVisible={setIsModifierToggleVisible}
          isButtonDisabled={!hasDiscountedProductIds}
        >
          <ModifierSelect
            productIds={discountedProductIds}
            label={modifiersLabel}
            helpText={modifiersHelpText}
            secondaryHelpText={modifiersSecondaryHelpText}
            shouldDisplayPopover={!isFreeModifier}
            name="onlineDiscountedModifierIds"
            value={discountedModifierIds}
            toggleVisibility={setIsModifierToggleVisible}
          />
        </ModifierToggle>
      </Switch>
    </>
  )
}

export default NotPurchase
